module.exports = __webpack_public_path__ + "static/media/trees.375597f5.svg";